import { z } from 'zod';

/** POST /v1/contact — public marketing-site enquiry form. */
/** First-touch marketing attribution captured by the web app (utm_*, ref,
 *  external referrer host, landing path). Non-PII, all optional. */
export const AttributionSchema = z
  .object({
    utm_source: z.string().max(120),
    utm_medium: z.string().max(120),
    utm_campaign: z.string().max(120),
    utm_term: z.string().max(120),
    utm_content: z.string().max(120),
    ref: z.string().max(120),
    referrer: z.string().max(255),
    landing: z.string().max(255),
  })
  .partial()
  .strict();
export type Attribution = z.infer<typeof AttributionSchema>;

export const ContactRequestSchema = z.object({
  name: z.string().min(1).max(120),
  email: z.string().email().max(254),
  company: z.string().max(120).optional(),
  phone: z.string().max(32).optional(),
  message: z.string().min(10).max(5000),
  attribution: AttributionSchema.optional(),
});
export type ContactRequest = z.infer<typeof ContactRequestSchema>;

export const ContactResponseSchema = z.object({
  received: z.literal(true),
});
export type ContactResponse = z.infer<typeof ContactResponseSchema>;
